/**
 * @file Functions for making http requests for order detailed
 * @author Max van Loosbroek
 */

import { IHttpResponse, IHttpService, IPromise } from 'angular'
import { URLS } from '../../../../../common/utilities/constants/constants.module'
import { OrderConceptRetrieved } from '../types/OrderConcept'
import { parseHttpError } from '../../../../../common/utilities/errorHandling'
import { OrderBody } from '../types/types'
import { DetailedTaasOrder } from '../../../../overview/types/types'

export interface SearchParamsOrderConcept {
  clientId?: string
  clientUuid?: string
}

export const getOrderConceptRequest = (
  $http: IHttpService,
  { clientId, clientUuid }: SearchParamsOrderConcept
): IPromise<IHttpResponse<OrderConceptRetrieved[]>> => {
  const params: SearchParamsOrderConcept = {}
  if (clientUuid) params.clientUuid = clientUuid
  if (clientId) params.clientId = clientId
  const url = URLS.admin.taasOrderConcepts
  return $http.get<OrderConceptRetrieved[]>(url, { params }).catch(parseHttpError)
}

export const getOrderConceptByIdRequest = (
  $http: IHttpService,
  conceptId: number
): IPromise<IHttpResponse<OrderConceptRetrieved>> => {
  const url = `${URLS.admin.taasOrderConcepts}/${conceptId}`
  return $http.get<OrderConceptRetrieved>(url).catch(parseHttpError)
}

export const createOrderFinalRequest = (
  $http: IHttpService,
  order: OrderBody
): IPromise<IHttpResponse<DetailedTaasOrder>> => {
  const url = URLS.admin.taasOrders
  return $http.post<DetailedTaasOrder>(url, order).catch(parseHttpError)
}
